import {query} from "@/graphql/client";
import {gql} from "@urql/vue";
import {MonthKpi} from "@/graphql/generated/graphql";
import {kapitelDateString, kapitelDateTimeString, kapitelMonthString, kapitelTimeString} from "@/graphql/kapitelTypes";
import month from "@/helper/datetime/month";
import datetime from "@/helper/datetime/datetime";
import date from "@/helper/datetime/date";
import {graphql} from "@/graphql/generated";

export const MONTH_KPI_MONTH_BACK = 6;
export const SHARE_PROFIT_DISTRIBUTION_EFFECTIVE_START_DATE = "2025-01-01";
export const PUBLISH_15 = 15;

/**
 * PRODUCTIVITY
 */
export const monthKpiFragment = graphql(`fragment MonthKpiFragment on MonthKPI {
    month
    
    # type of productivity value
    accountedForAbsences
    productivityScope
    
    # productivity value
    productivity
}`)


export async function fetchMonthKPI(month: kapitelDateString): Promise<MonthKpi> {
    const result = await query(
        graphql(`
            query getMonthKPI($month: KapitelDateImmutable!) {            
            monthKPI(month: $month) {
                ...MonthKpiFragment
            }
        }`),
        {month}
    )

    return result.data.monthKPI
}


export async function fetchMonthKPIList(months: kapitelDateString[]): Promise<MonthKpi[]> {
    const result = await query(
        graphql(`
            query getMonthKPIList($months: [KapitelDateImmutable!]!) {            
            monthKPIList(months: $months) {
                ...MonthKpiFragment
            }
        }`),
        {months}
    )

    return result.data.monthKPIList
}





export const getPublishTimeForMonth = (m: kapitelMonthString) : kapitelDateTimeString => {
        return datetime.convertDateAndTime2DateTime(
            date.setDayOfMonth(
                month.add(m, 1),
                PUBLISH_15
            ),
            PUBLISH_15.toString()+':'+PUBLISH_15.toString() as kapitelTimeString
        )
}
export const getMostRecentPublishedMonth = () : kapitelMonthString => getMostRecentPublishedMonthForPIT(datetime.getNow())
export const isMostRecentPublishedMonth = (month: kapitelMonthString) => month === getMostRecentPublishedMonth()
export const getMostRecentPublishedMonthForPIT = (pit: kapitelDateTimeString) : kapitelMonthString =>  {
    const pitMonth = month.getKapitelMonthFromKapitelDate(datetime.convertDateTime2Date(pit))
    const recentMonth = month.sub(pitMonth, 1)

    return !datetime.isBefore(pit, getPublishTimeForMonth(recentMonth))
        ? recentMonth
        : month.sub(recentMonth,1)
}
